const themeFolder = 'theme/'
export default {
    ns: {
        logo: themeFolder + 'ns/logo.svg',
        style: themeFolder + 'ns/style-ns.scss',
        chat: themeFolder + 'ns/chat-ns.css',
        text: {
        }
    },
    vero: {
        logo: themeFolder + 'vero/logo.svg',
        style: themeFolder + 'vero/style-vero.scss',
        chat: themeFolder + 'vero/chat-vero.css',
        exit: 'http://verointernet.com.br',
        text: {
            name: "Vero Especialista!",
            first: "Ele sabe tudo de internet, tecnologia e está pronto para te ajudar. Se for necessário, ele vai conectar você com um de nossos especialistas.",
            guide: "Olá! Sou o Veríssimo e vou guiar você na sua primeira visita ao atendimento do Vero Especialista."
        },
        favicon: themeFolder + 'vero/favicon.ico'
    }
}